import type { ModuleTypes } from "@repo/database";
import React from "react";
import { useTranslation } from "react-i18next";

export default function ModuleNotActivated({
  module,
}: {
  module: ModuleTypes;
}) {
  const { t } = useTranslation("common");
  return (
    <div className="absolute inset-0 bg-black/70 flex justify-center items-center">
      {t("module_not_active", { module_name: module })}
    </div>
  );
}
